// components/TallyButton.js
import React from 'react';

const TallyButton = ({ url = 'https://tally.so/r/mB6r9Q' }) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '60px',
        right: '30px',
        backgroundColor: 'white',
        color: 'black',
        padding: '12px 20px',
        borderRadius: '999px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        textDecoration: 'none',
        fontWeight: 'bold',
        zIndex: 1000,
      }}
    >
      Consultation Quote
    </a>
  );
};

export default TallyButton;
